export default {
  /// <summary>
  /// Cấp tỉnh
  /// </summary>
  Province: 1,
  /// <summary>
  /// Cấp huyện
  /// </summary>
  District: 2,
  /// <summary>
  /// Cấp xã
  /// </summary>
  Commune: 3,
};
